import React, { forwardRef } from "react";
import styles from "./scss/AppointmentForm.module.scss";
import cx from "clsx";
import classesResponsive from "../../../Shared/scss/Responsive.module.scss";
import SectionTitle from "../../../Shared/SectionTitle";
import Input from "../../../Shared/Input";
import Checkbox from "../../../Shared/Checkbox";
import Button from "../../../Shared/Button";
import PhoneIcon from "../../../Shared/Icons/PhoneIcon";
import MailIcon from "../../../Shared/Icons/MailIcon";
import Textarea from "../../../Shared/Textarea";

const AppointmentForm = forwardRef((_props, ref) => {
  return (
    <div
      className={cx(
        styles.appointmentFormContainer,
        classesResponsive.paddingLeftRight
      )}
      ref={ref}
    >
      <SectionTitle>
        Hai să ne <span>cunoaștem</span>
      </SectionTitle>
      <div className={styles.contactContainer}>
        <div className={styles.flexContainer}>
          <img src="/images/logo.jpeg" alt="" className={styles.logo} />
          <p>
            Completează formularul și vei primi un telefon din partea colegilor
            noștri pentru a stabili detaliile finale necesare efectuării
            programării.
          </p>
          <div>
            <div className={styles.contactInfo}>
              <PhoneIcon />
              <span>Telefon: 0761111111</span>
            </div>
            <div className={styles.contactInfo}>
              <MailIcon />
              <span>Email: contact@artdent.com</span>
            </div>
          </div>
        </div>
        <div className={styles.formContainer}>
          <Input label="Nume" type="text" name="nume" id="nume" />
          <Input label="Prenume" type="text" name="nume" id="nume" />
          <Input label="Numar de Telefon" type="text" name="nume" id="nume" />
          <Textarea
            label="Mesaj (optional)"
            type="text"
            name="mesaj"
            id="mesaj"
          />
          <div className={styles.checkboxesContainer}>
            <Checkbox
              name="confirm"
              id="confirm"
              label="Prin completarea acestui formular îmi dau acordul explicit să fiu contactat telefonic în vederea realizării unei programări și obținerea mai multor informații despre tratamentul solicitat."
            />
            <Checkbox
              name="terms"
              id="terms"
              label="Sunt de acord și am luat la cunoștință despre Termenii și condițiile site-ului și Politica de prelucrare a datelor cu caracter personal."
            />
          </div>
          <Button className={styles.formSubmit}>Trimite Formularul</Button>
        </div>
      </div>
    </div>
  );
});

export default AppointmentForm;
